import React from 'react'

import {
  Button,
  Icon,
  Edit,
  classnames,
} from '@cgtrader/triangle-ui/dist/src/ssr-index'
import { string } from 'prop-types'

import { usePreviewMode } from 'Pods/ItemPage/context/PreviewModeContext'

/**
 * Edit button displayed in preview mode.
 * Links to the item edit page.
 */
function PreviewEditButton({ className = '' }) {
  const { isPreview, editUrl } = usePreviewMode()

  if (!isPreview || !editUrl) {
    return null
  }

  return (
    <Button
      href={editUrl}
      type="ghost-primary"
      variant="with-icon"
      icon={<Icon svgComponent={Edit} />}
      customClass={classnames('preview-edit-button', className)}
      aria-label="Edit this item"
      size="small"
    >
      Edit
    </Button>
  )
}

PreviewEditButton.propTypes = {
  className: string,
}

export default PreviewEditButton
